<template>
  <ag-card-container
    :title="$t('networkdiagram.title.main')"
    fluid
  >
    <instruction-list
      v-if="instructionList"
      v-model="instructionList"
      @input="listChanged = true"
    />
    <ag-float-button-container>
      <v-btn
        v-if="listChanged"
        color="secondary"
        fab
        @click="fetchData"
      >
        <v-icon>mdi-restore</v-icon>
      </v-btn>
      <v-btn
        v-if="listChanged"
        :loading="loadingSave"
        color="accent"
        fab
        @click="save"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn
        :disabled="listChanged"
        to="/networkdiagram/create"
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import InstructionList from '../components/InstructionList'

export default {
  name: 'InstructionListContainer',
  components: {
    AgCardContainer,
    InstructionList,
    AgFloatButtonContainer,
  },
  data: () => ({
    loadingData: false,
    loadingSave: false,
    listChanged: false,
    instructionList: [],
    selectedInstructionList: [],
  }),
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'NetworkdiagramInstructionList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      const { instructionList } = await Repositories.networkDiagram.instruction.getList()
      this.instructionList = instructionList
      this.loadingData = false
      this.listChanged = false
    },
    async save () {
      this.loadingSave = true
      try {
        await Repositories.networkDiagram.instruction.patch({
          instructionList: this.instructionList.map((item, index) => ({
            ...item,
            order: index + 1,
          })),
        })
        this.showSuccessNotification(this.$t('networkdiagram.fields.success.instructionUpdated'))
        this.listChanged = false
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loadingSave = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
